<template>
  <div v-if="filterData && filterData.length > 0">
    <div
      class="search-class-nav"
      :class="{ 'search-class-nav-fold': !isOpen }"
    >
      <div
        v-for="(filter_item, filter_index) in filterData"
        :key="filter_index"
        class="search-class-nav-container"
      >
        <div :class="`search-class-nav-box search-nav-${filter_index}`">
          <a
            class="search-class-nav-li"
            href="javascript:void(0);"
            :class="+filter_item.selected === -1 ? 'cur' : ''"
            :uigs="getUigs(filter_item.name, '全部', 0, filter_item.option_name)"
            @click="filterClassNav(-1, filter_index, false)"
          >
            <span v-if="filter_item.option_name !== 'order'">全部</span>
            <span v-else>最热</span>
          </a>
          <a
            v-for="(item, index) in filter_item.option_list"
            :key="index"
            class="search-class-nav-li"
            :class="+filter_item.selected === index ? 'cur' : ''"
            href="javascript:void(0);"
            :uigs="getUigs(filter_item.name, item, index + 1, filter_item.option_name)"
            @click="filterClassNav(index, filter_index, false)"
          >
            <span>{{ item }}</span>
          </a>
        </div>
      </div>
      <div
        v-show="!isOpen"
        class="search-class-nav-more"
        @click="isOpen = true"
      >
        展开<i />
      </div>
      <div
        v-show="isOpen"
        class="search-class-nav-retract"
        @click="isOpen = false"
      >
        收起
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    filterData: {
      type: Array,
      default: () => [],
    },
    filterClassNav: {
      type: Function,
      default: () => null,
    },
    getUigs: {
      type: Function,
      default: () => null,
    },
  },
  data() {
    return {
      isOpen: false,
    };
  },
  mounted() {
    this.isOpen = this.$route.query.fr === 'filter';
    // 初始化时将选中的tab展示在屏幕中间
    this.nacScroll();
  },
  methods: {
    nacScroll() {
      const navList = document.querySelectorAll('.search-class-nav-box') || [];
      const windowWidth = window.innerWidth;
      if (navList.length) {
        Array.prototype.forEach.call(navList, (item, i) => {
          const cur = document.querySelector(`.search-nav-${i} .cur`);
          const curOffset = (cur && cur.offsetLeft) || 0;
          if (curOffset > windowWidth) {
            const left = curOffset - parseInt(windowWidth / 2, 10);
            item.scrollTo(left, 0);
          }
        });
      }
    },
  },
};
</script>
<style lang="scss">
.search-class-nav {
  margin-top: 15px;
  position: relative;
  font-size: 14px;
}
.search-class-nav-fold {
  height: 30px;
  overflow: hidden;
}
.search-class-nav-retract {
  position: absolute;
  bottom: 0px;
  right: 15px;
  line-height: 30px;
  &:after {
    width: 6px;
    height: 6px;
    transform: rotate(-45deg);
    -ms-transform: rotate(-45deg);
    -moz-transform: rotate(-45deg);
    -webkit-transform: rotate(-45deg);
    -o-transform: rotate(-45deg);
    border-top: 1px solid #555;
    border-right: 1px solid #555;
    display: inline-block;
    vertical-align: middle;
    content: '';
    margin-left: 7px;
    margin-top: 2px;
  }
}
.search-class-nav-more {
  position: absolute;
  right: 0px;
  top: 0px;
  line-height: 30px;
  padding-right: 14px;
  color: rgba(34, 34, 34, 1);
  background-color: #ffffff;
  &:before {
    content: '';
    display: block;
    position: absolute;
    top: 0;
    right: 55px;
    width: 55px;
    height: 30px;
    background: -webkit-gradient(linear, right top, left top, from(#ffffff), to(hsla(0, 0%, 100%, 0)));
    background: -webkit-linear-gradient(right, #ffffff, hsla(0, 0%, 100%, 0));
    background: -moz-linear-gradient(right, #ffffff, hsla(0, 0%, 100%, 0));
    background: linear-gradient(90deg, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 1) 100%);
  }
  i {
    &:after {
      width: 6px;
      height: 6px;
      transform: rotate(135deg);
      -ms-transform: rotate(135deg);
      -moz-transform: rotate(135deg);
      -webkit-transform: rotate(135deg);
      -o-transform: rotate(135deg);
      border-top: 1px solid #555;
      border-right: 1px solid #555;
      display: inline-block;
      vertical-align: middle;
      content: '';
      margin-left: 7px;
      margin-top: -2px;
    }
  }
}
.search-class-nav-container {
  margin-bottom: 12px;
  height: 30px;
  overflow: hidden;
  .search-class-nav-box {
    overflow: scroll;
    -webkit-overflow-scrolling: touch;
    white-space: nowrap;
    height: 50px;
    padding: 0 14px;
  }
  .cur {
    background: rgba(245, 245, 245, 0.7);
    border-radius: 2px;
    color: rgba(226, 43, 0, 1);
  }
  .search-class-nav-li {
    display: inline-block;
    span {
      height: 30px;
      display: inline-block;
      line-height: 30px;
      padding-left: 16px;
      padding-right: 16px;
      margin-left: 1px;
    }
  }
}
</style>
